import React from "react";

// Sol menü bildirim turuncusu — Kayıt Talepleri noktası ve tema turuncusu (#E56A22) ile aynı.
const ORANGE = "#E56A22";
const ORANGE_RING = "rgba(229,106,34,0.35)";

/**
 * Menü öğesinin yanında gösterilen sayaç rozeti.
 * Sayı 0/negatif/tanımsız ise hiçbir şey render edilmez.
 *
 * dot=true: sayı yerine yalnızca nokta gösterir. Sayaç üst menüde dururken
 * bildirimin hangi alt menüden geldiğini işaretlemek için kullanılır.
 *
 * overlay=true: rozet metnin yanına akmak yerine ikonun sağ üstüne oturur.
 * Üst bardaki .noti-icon butonlarında (destek kısayolu, bildirim zili) kullanılır;
 * konumu _topbar.scss'teki ".noti-icon .badge" kuralından gelir, böylece zil
 * rozetiyle aynı noktada durur.
 */
const MenuCountBadge = ({ count, title, dot = false, overlay = false }) => {
    if (!count || count <= 0) {
        return null;
    }

    // Akış içi rozetler metinden 8px ayrılır; overlay modunda konumu CSS verir.
    const positioning = overlay
        ? {}
        : { marginLeft: "8px", verticalAlign: "middle" };

    // Sınıflar yalnızca konumlandırma için; renk/ölçü inline stillerden gelir.
    // menu-count-badge: daraltılmış sol menünün rozeti ikonun soluna alması için CSS kancası
    // (_vertical.scss, body[data-sidebar-size="sm"]). Tek başına görünümü değiştirmez.
    const className = overlay ? "badge menu-count-badge" : "menu-count-badge";

    if (dot) {
        return (
            <span
                className={className}
                title={title}
                style={{
                    display: "inline-block",
                    width: "9px",
                    height: "9px",
                    padding: 0,
                    borderRadius: "50%",
                    backgroundColor: ORANGE,
                    boxShadow: `0 0 0 2px ${ORANGE_RING}`,
                    ...positioning,
                }}
            />
        );
    }

    return (
        <span
            className={className}
            title={title}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "18px",
                height: "18px",
                padding: "0 6px",
                borderRadius: 999,
                backgroundColor: ORANGE,
                boxShadow: `0 0 0 2px ${ORANGE_RING}`,
                color: "#fff",
                fontSize: ".68rem",
                fontWeight: 600,
                lineHeight: 1,
                ...positioning,
            }}
        >
            {count}
        </span>
    );
};

export default MenuCountBadge;
